export class AssetLocation {

    constructor(ext_asset_location?: string, long_description?: string) {
        this.ext_asset_location = ext_asset_location;
        this.long_description = long_description;
    }

    ext_asset_location: string;
    long_description: string;
}